import React from "react";

import { Spinner } from "@performyard/py-components";

import InputTextArea from "../../../../components/Inputs/InputTextArea";
import NotesDropdownHeader from "./NotesDropdownHeader";

import type { NotesData } from "../types";

import { config } from "../config";

type PublicNotesSectionProps = {
	notesData: NotesData;
	isNotesLoading: boolean;
	isNotesDisabled: boolean;
	showPrimaryPublicNotes: boolean;
	publicNoteContent: string;
	showPublicNotesSaved: boolean;
	showPublicNotesSaving: boolean;
	isPublicNotesError: boolean;
	onPublicNotesOptionSelect: (optionId: "my-notes" | "participant-notes") => void;
	onPublicNoteChange: (value: string) => void;
};

/**
 * Public notes section with dropdown to switch between participants' notes.
 * Displays the shared notes editor with autosave status.
 */
const PublicNotesSection = ({
	notesData,
	isNotesLoading,
	isNotesDisabled,
	showPrimaryPublicNotes,
	publicNoteContent,
	showPublicNotesSaved,
	showPublicNotesSaving,
	isPublicNotesError,
	onPublicNotesOptionSelect,
	onPublicNoteChange,
}: PublicNotesSectionProps): React.ReactElement => {
	const currentNoteValue = showPrimaryPublicNotes ? publicNoteContent : notesData.secondaryPublicNotes?.content || "";

	return (
		<div className="flex flex-col gap-2">
			<NotesDropdownHeader
				showMyPublicNotes={showPrimaryPublicNotes}
				showPublicNotesSaved={showPublicNotesSaved}
				showPublicNotesSaving={showPublicNotesSaving}
				onOptionSelect={onPublicNotesOptionSelect}
				isPublicNotesError={isPublicNotesError}
			/>
			{isNotesLoading ? (
				<div className="flex items-center justify-center py-8">
					<Spinner size={config.spinnerSize.medium} />
				</div>
			) : (
				<InputTextArea
					minRows={config.layout.notesMinRows}
					maxRows={config.layout.notesMaxRows}
					placeholder="Add shared notes..."
					value={currentNoteValue}
					onChange={(value) => onPublicNoteChange(value)}
					disabled={isNotesDisabled || !showPrimaryPublicNotes}
				/>
			)}
		</div>
	);
};

export default PublicNotesSection;
